import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';

import { canAccessEntityKey } from '../config/entity-config';
import { RoleAccessService } from '../services/role-access.service';

/**
 * Resolves management entity key from the activated route (including provider hub).
 */
function entityKeyFromRoute(route: ActivatedRouteSnapshot): string | null {
  const direct = route.paramMap.get('entityKey') ?? (route.data['entityKey'] as string | undefined);
  if (direct) {
    return direct;
  }
  const path = route.routeConfig?.path ?? '';
  if (path.includes('providers') && path.includes('hub')) {
    return 'providers';
  }
  if (path.includes('provider-balances') && path.includes('hub')) {
    return 'provider-balances';
  }
  const parts = route.pathFromRoot.flatMap((r) => r.url.map((u) => u.path));
  const mi = parts.indexOf('manage');
  if (mi >= 0 && parts[mi + 1] === 'providers' && parts[parts.length - 1] === 'hub') {
    return 'providers';
  }
  return null;
}

/**
 * Blocks `/manage/...` when the user's effective role may not access that entity.
 */
export const entityRoleGuard: CanActivateFn = (route): boolean | UrlTree => {
  const roleAccess = inject(RoleAccessService);
  const router = inject(Router);
  const key = entityKeyFromRoute(route);
  if (!key) {
    return true;
  }
  if (!canAccessEntityKey(key, roleAccess.effectiveRole())) {
    return router.createUrlTree(['/']);
  }
  return true;
};
